const APPLICATION_FEES = 199900

export { APPLICATION_FEES }
